import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'SM',
  name: 'S.M.',
  role: 'Hip Hop Dance Instructor — London, UK',
  text: '"I stopped spending my Sunday nights building class structures from scratch. I open the library, pick the class, and walk in completely prepared. My students feel the difference — and so do I."'
}, {
  initials: 'CV',
  name: 'C.V.',
  role: 'Hip Hop Dance Instructor — Toronto, Canada',
  text: '"Just the Cueing & Corrections Library saved me three times in my first month. That bonus alone is worth the full price."'
}, {
  initials: 'JR',
  name: 'J.R.',
  role: 'Hip Hop Dance Instructor — Sydney, Australia',
  text: '"The Mixed-Level Modification System completely changed the way I teach. My progressions are smoother, my language is clearer, and my students stay focused from the very first groove to the final cool-down."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-cream-dark border-y border-line" data-id="element-286" data-mp="ce0j5jr39v0p">
      <div className="max-w-7xl mx-auto px-4" data-id="element-287" data-mp="gdsvm7jlslbc">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-288" data-mp="gekhurrb96oy">
          {testimonials.map((t, i) => <motion.article key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-cream-light border border-gold/60 p-6 rounded-2xl relative shadow-sm" data-id="element-289" data-mp="lbubykpna6j4" data-mpi={i}>
              <div className="flex gap-1 text-gold-dark mb-4" aria-label="5 out of 5 stars" data-id="element-290" data-mp="14451lcvag7za">
                {[...Array(5)].map((_, j) => <StarIcon key={j} size={16} fill="currentColor" data-id="element-291" data-mp="35v9sg6ped4ik" data-mpi={j} />)}
              </div>
              <p className="text-ink-soft italic mb-6 text-sm leading-relaxed" data-id="element-292" data-mp="3au35xz4ooviq">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-293" data-mp="hz2ztjud40a4">
                <div className="w-10 h-10 rounded-full bg-burgundy text-cream-light flex items-center justify-center font-bold" data-id="element-294" data-mp="i1pgqa357s50">
                  {t.initials}
                </div>
                <div data-id="element-295" data-mp="r1uf5uqczg71">
                  <div className="font-bold text-ink text-sm" data-id="element-296" data-mp="qy6lmvkwytsb">{t.name}</div>
                  <div className="text-xs text-burgundy" data-id="element-297" data-mp="m050m53xgke7">{t.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}